import { POSTGREST_PAGE_SIZE } from "@/utils/constants";
import { PostgrestError } from "@supabase/supabase-js";

interface PageResult<T> {
  data: T[] | null;
  error: PostgrestError | null;
}

const MAX_PAGES = 200;

/**
 * Fetches every page of a PostgREST query.
 * PostgREST returns at most 1000 rows per request and does not error when
 * more rows exist, so list queries must keep paging until a short page.
 */
export const fetchAllPages = async <T>(
  fetchPage: (from: number, to: number) => PromiseLike<PageResult<T>>,
  pageSize: number = POSTGREST_PAGE_SIZE,
): Promise<T[]> => {
  const allRows: T[] = [];

  for (let page = 0; page < MAX_PAGES; page += 1) {
    const from = page * pageSize;
    const { data, error } = await fetchPage(from, from + pageSize - 1);

    if (error) {
      throw new Error(error.message);
    }

    const rows = data ?? [];
    allRows.push(...rows);

    if (rows.length < pageSize) {
      break;
    }
  }

  return allRows;
};
